<template>
    <div class="content-wrapper  " style="background-color:#eee ; height: 100%">
        <div class="container">

            <div class="form-group" style="margin-top: 30px">
                <router-link to="/role/list" class="btn btn-default">{{ $t('Back') }}</router-link>
            </div>

            <div class="panel panel-default">
                <div class="panel-heading">{{ $t('Add') }}</div>
                <div class="panel-body">
                    <form v-on:submit.prevent="saveForm()">
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('role') }}</label>
                                <input type="text" v-model="item.name" class="form-control">
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">{{ $t('Description') }}</label>
                                <input type="text" v-model="item.description" class="form-control">
                            </div>
                        </div>
                        <!-- <div class="row">
                            <div class="col-xs-12 form-group">
                                <label class="control-label">نقش</label>
                                <input type="text" v-model="item.final_price" class="form-control">
                            </div>
                        </div> -->
                        <div class="row">
                            <div class="col-xs-12 form-group">
                                <button class="btn btn-success">{{ $t('Add') }}</button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const auth = {
        headers: {
            Authorization: 'bearer ' + localStorage.getItem('token')
        }

    };

    export default {
        data: function () {
            return {
                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                item: {
                    name: '',
                    description: ''
                },
                errors: [],
            }
        },

        mounted() {
            // axios
            //     .get('/api/productCategories', auth)
            //     .then(response => {

            //         this.product_categories = response.data.data;

            //     })
            //     .catch(error => {
            //         console.log(error);
            //         this.errored = true
            //     })

        }


        ,

        methods: {
            saveForm() {
                var app = this;
                var newItem = app.item;
                axios.post('/admin-api/v1/role/add', newItem, app.auth)
                    .then(function (resp) {
                        app.$snotify.info('با موفقیت ثبت شد')
                        app.$router.push({
                            path: '/role/list'
                        });
;

                    })
                    .catch(
                        e => {

                            app.errors.push(e.response.data.messages);
                            for (let value of e.response.data.messages_fa) {
                                //                        for (let error of Object.entries(value[1])) {
                                //                            console.log(app.object.entries(app.errors[0]));

                                app.$snotify.warning(value, {
                                    timeout: 7000,
                                    //                                    showProgressBar: false,
                                    closeOnClick: true,
                                    pauseOnHover: true
                                });

                                //                        }
                            }

                        }

                    );


            }
        }
    }

</script>
